/** @format */
import { TOtherPaths } from '@/ducks/filters/declarations';
import { TLocale } from '@/utils/gatsby/types';

export const utilityGetCurrentURL = ({ locale, otherPaths }: { locale: TLocale; otherPaths?: TOtherPaths }): string => {
  if (!otherPaths || !Object.values(otherPaths).length) {
    return '/';
  } else {
    return `/${otherPaths[locale] ?? otherPaths.en}/`.replaceAll('//', '/');
  }
};
